import { LogOut } from 'lucide-react';
import { useLogout, type AdminUser } from '../../hooks/useAuth';
import { Button } from '../ui/Button';
import { LangSwitcher } from '../LangSwitcher';
import { useT } from '../../i18n';

export function Header({ user, title }: { user: AdminUser; title: string }) {
  const logout = useLogout();
  const t = useT();
  return (
    <header className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-6">
      <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
      <div className="flex items-center gap-3 text-sm">
        <LangSwitcher compact />
        <span className="text-slate-600">@{user.telegram_id}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => logout.mutate()}
          loading={logout.isPending}
        >
          <LogOut className="h-4 w-4" />
          {t('header.logout')}
        </Button>
      </div>
    </header>
  );
}
